import axios from "axios";
import { backendURL } from "../url";

const API_URL = "/api/enquiry";

export const fetchEnquiries = async () => {
  try {
    const response = await axios.get(
      `${backendURL}${API_URL}/get-enquiry`
      // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/get-enquiry`
    );
    return response.data.enquiries;
  } catch (error: any) {
    console.error("Error fetching enquiries:", error.message);
    throw error;
  }
};
